import React from 'react';
import { GraduationCap, Calendar, MapPin, Star } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const Education = () => {
  const education = [
    {
      degree: 'Doctor of Philosophy (PhD)',
      field: 'Mechanical and Aerospace Engineering',
      institution: 'IIT Bombay-Monash Research Academy',
      location: 'Mumbai and Melbourne',
      year: '2015',
      thesis: 'Studies in the use of element-free Galerkin method for linear elastic fracture mechanics',
      cgpa: '9.74/10',
      color: 'from-blue-600 to-cyan-500',
      bgColor: 'bg-blue-50',
    },
    {
      degree: 'Bachelor of Technology (B.Tech)',
      field: 'Mechanical Engineering',
      institution: 'Indian Institute of Technology Guwahati',
      location: 'Guwahati',
      year: '2008',
      cgpa: '8.59/10',
      color: 'from-cyan-500 to-purple-500',
      bgColor: 'bg-cyan-50',
    },
  ];

  return (
    <section id="education" className="section-container bg-gradient-to-br from-slate-50 via-blue-50 to-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-cyan-200 to-purple-200 rounded-full filter blur-3xl opacity-20"></div>
      
      <h2 className="section-title">Academic Qualifications</h2>
      
      <div className="w-full space-y-6 relative z-10">
        {education.map((edu, index) => (
          <Card key={index} className="border-2 border-transparent hover:border-blue-200 overflow-hidden group hover-lift">
            <div className={`h-2 bg-gradient-to-r ${edu.color}`}></div>
            <CardHeader className={`${edu.bgColor} bg-opacity-50`}>
              <CardTitle className="flex items-start gap-4">
                <div className={`bg-gradient-to-br ${edu.color} p-4 rounded-xl shadow-lg transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-500`}>
                  <GraduationCap size={32} className="text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent mb-2">
                    {edu.degree}
                  </h3>
                  <p className="text-lg text-slate-700 font-semibold">{edu.field}</p>
                </div>
              </CardTitle>
            </CardHeader>
            <CardContent className="pl-20 pt-6">
              <div className="space-y-3">
                <div className="flex items-center gap-3 text-slate-600 bg-white p-3 rounded-lg shadow-sm">
                  <MapPin size={18} className="text-blue-600" />
                  <span className="font-semibold">{edu.institution}</span>
                  <span className="text-slate-400">•</span>
                  <span>{edu.location}</span>
                </div>
                <div className="flex items-center gap-3 text-slate-600 bg-white p-3 rounded-lg shadow-sm">
                  <Calendar size={18} className="text-cyan-500" />
                  <span>Graduated: <span className="font-semibold">{edu.year}</span></span>
                </div>
                {edu.thesis && (
                  <p className="text-slate-600 mt-3 p-3 bg-blue-50 rounded-lg border-l-4 border-blue-500">
                    <span className="font-semibold text-blue-700">Thesis:</span> {edu.thesis}
                  </p>
                )}
                <div className="flex items-center gap-2 mt-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white px-4 py-2 rounded-full w-fit">
                  <Star size={18} />
                  <span className="font-bold">CGPA: {edu.cgpa}</span>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default Education;